import { render, staticRenderFns } from "./FlowLists.vue?vue&type=template&id=0c1ad8d2&scoped=true&"
import script from "./FlowLists.vue?vue&type=script&lang=js&"
export * from "./FlowLists.vue?vue&type=script&lang=js&"
import style0 from "./FlowLists.vue?vue&type=style&index=0&id=0c1ad8d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1ad8d2",
  null
  
)

export default component.exports